import { Constructor } from '@angular/cdk/table';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type WithContentSetFormSectionType = {
  _initContentSetHeadline(contentSetHeadline: string): void;
  _initContentSetHeadlineValueChanges(
    getPreviousContentSetHeadline: () => string | null
  ): void;
  _buildContentSetHeadline(): string;
};

type ContentSetHeadlineFormSectionRequirementsBase = {
  form: FormGroup;
  FORM_PATHS: { CONTENT_SET_HEADLINE: () => string };
  destroy$: Subject<boolean>;
};

export function WithContentSetHeadlineFormSection<
  TBase extends Constructor<ContentSetHeadlineFormSectionRequirementsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithContentSetFormSectionType;
  prototype: WithContentSetFormSectionType;
} & TBase {
  return class WithContentSetHeadlineFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initContentSetHeadline(contentSetHeadline: string): void {
      this.form
        .get(this.FORM_PATHS.CONTENT_SET_HEADLINE())
        .setValue(contentSetHeadline);
    }

    _initContentSetHeadlineValueChanges(
      getPreviousContentSetHeadline: () => string | null
    ): void {
      this.form
        .get(this.FORM_PATHS.CONTENT_SET_HEADLINE())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousContentSetHeadline()) {
              this.form
                .get(this.FORM_PATHS.CONTENT_SET_HEADLINE())
                .markAsPristine();
            }
          },
        });
    }

    _buildContentSetHeadline(): string {
      return this.form.get(this.FORM_PATHS.CONTENT_SET_HEADLINE()).value;
    }
  };
}
